import { Drawer } from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const DrawerContainer = styled(Drawer)`
  position: fixed;
  display: flex;
  .MuiDrawer-paper {
  }
  .MuiTimelineOppositeContent-root {
    flex: unset;
    padding: 0;
  }
  .MuiTimelineDot-root {
    color: rgba(84, 147, 189, 1);
    background-color: rgba(212, 236, 255, 1);
    box-shadow: unset;
    width: 12px;
    height: 12px;
  }
`;

export const DrawerDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 514px;
  min-width: 375px;

  .divider {
    width: 100%;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    min-width: 375px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    padding-bottom: 23px;
  }
  .title {
    color: ${COLORS.BLUE};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0075c9;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }

  .action-buttons-container {
    padding: 0 10px;
  }

  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }

  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .content {
    flex: 1;
    overflow-y: auto;
  }
`;
export const StyledPaper = {
  backgroundColor: '#E8F5EC',
  borderRadius: '13px',
  padding: '10px',
  border: '1px solid #c1d9c9',
};
export const StyledTitle = {
  color: 'rgba(0, 0, 0, 1)',
  fontSize: '14px',
  fontWeight: 400,
};
export const StyledDate = {
  color: 'rgba(0, 0, 0, 1)',
  fontSize: '12px',
  fontWeight: 400,
};
export const StyledPaperBlue = {
  backgroundColor: '#D0E8F4',
  borderRadius: '13px',
  padding: '10px',
  border: '1px solid #A0C8E1',
};
export const StyledTitleBlue = {
  color: 'rgba(0, 0, 0, 1)',
  fontSize: '14px',
  fontWeight: 400,
};
